import Image from "next/future/image";
import { useIntl } from "react-intl";
import styles from "./styles/style.module.scss";
// Import Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/autoplay";
// Import Components
import Heading from "@/components/Shared/Heading/Heading";
// Import Images
import StarRedFull from "@/assets/svgs/Star.svg";
import logoIconSmall from "@/assets/images/logoIconSmall.png";
import logoIconSmallDark from "@/assets/images/logoIconSmallDark.png";

const Opinions = ({ customeropinions }) => {
  const { locale } = useIntl();
  const dir = locale === "ar" ? "rtl" : "ltr";
  const renderOpinionSlides = customeropinions?.content?.items?.map(
    (item, index) => {
      return (
        <SwiperSlide key={index} aria-label={`Customer opinion ${index + 1}`}>
          <div className="card">
            <div className="image-div">
              <Image
                src={logoIconSmall}
                alt="logoIcon"
                className="logo-light"
                width={100}
                height={100}
                loading="lazy"
                priority={false}
              />
              <Image
                src={logoIconSmallDark}
                alt="logoIcon"
                className="logo-dark"
                width={100}
                height={100}
                loading="lazy"
                priority={false}
              />
            </div>
            <div className="content">
              <div className="rate">
                {Array.from({ length: 5 }).map((_, i) => (
                  <StarRedFull
                    key={i}
                    style={{
                      fill:
                        i < parseInt(item?.subTitle?.[locale])
                          ? "#ffb422"
                          : "#C5C5C5",
                    }}
                  />
                ))}
              </div>
              <blockquote className="card-qoute">
                {item?.description?.[locale]}
              </blockquote>
              <div className="info-user">
                <h3 className="name">{item?.name}</h3>
                <h4 className="job">{item?.job}</h4>
              </div>
            </div>
          </div>
        </SwiperSlide>
      );
    }
  );
  return (
    <section
      className={`${styles["mainOpinions"]} mainOpinions`}
      aria-labelledby="customer-opinions-heading"
    >
      <Heading
        title={customeropinions?.title?.[locale]}
        subTitle={customeropinions?.subTitle?.[locale]}
      />
      <div className="all-qoutes">
        <Swiper
          dir={dir}
          slidesPerView={2.7}
          spaceBetween={25}
          loop={true}
          modules={[Pagination, Autoplay, FreeMode]}
          className="mySwiper"
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          speed={12000}
          navigation={false}
          breakpoints={{
            // when window width is >= 320px
            100: {
              slidesPerView: 1.2,
              spaceBetween: 20,
            },
            576: {
              slidesPerView: 1.2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2.2,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 3.3,
              spaceBetween: 20,
            },
            1400: {
              slidesPerView: 4.3,
              spaceBetween: 25,
            },
            1900: {
              slidesPerView: 5.3,
              spaceBetween: 25,
            },
          }}
        >
          {renderOpinionSlides}
        </Swiper>
      </div>
    </section>
  );
};

export default Opinions;
